import { AUTH_INFO_ID, CONTRACT_ID, PARTNER_ID, SETTLE_INVOICE_ID, SVC_ID } from '@/constants/routes';

type PathParamsPattern =
  | typeof AUTH_INFO_ID
  | typeof SVC_ID
  | typeof PARTNER_ID
  | typeof CONTRACT_ID
  | typeof SETTLE_INVOICE_ID;

export type PathParams = Partial<Record<PathParamsPattern, string | number>>;

export const replacePathParams = (route: string, params: PathParams) => {
  let replacedRoute = route;
  Object.entries(params).forEach(([pattern, segment]) => {
    replacedRoute = replacedRoute.replace(`:${pattern}`, String(segment));
  });
  return replacedRoute;
};

export const setSearchParams = (query: string, value: string, replaceHistory?: boolean) => {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set(query, value);
  if (replaceHistory) {
    history.replaceState(null, '', `?${searchParams.toString()}`);
  } else {
    history.pushState(null, '', `?${searchParams.toString()}`);
  }
};

export const getParamsFromRoute = (route: string) => {
  const routeParts = route.split('/').filter(Boolean);
  const actualParts = window.location.pathname.split('/').filter(Boolean);

  if (routeParts.length !== actualParts.length) {
    throw new Error('Route template and actual route do not match in length');
  }

  const params = routeParts.reduce((acc: Record<string, string>, part, index) => {
    if (part.startsWith(':')) {
      const paramName = part.slice(1);
      acc[paramName] = actualParts[index];
    }
    return acc;
  }, {});

  return params;
};
